import React, { useEffect } from 'react';
import { MdOutlineFavorite, MdOutlineFavoriteBorder } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { getLikes, addLike, deleteLike } from "../../actions/like";
import axios from "axios";
import { LOGOUT } from "../../constants/actionTypes";

function Like({ singlepost = false, posts, post, loginUser }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const likeState = useSelector((state) => state.likeReducer);
    const postLikes = likeState.likes[post?.id] || [];
    const liked = loginUser && postLikes.includes(loginUser.id);

    // ✅ get likes initially
    useEffect(() => {
        if (singlepost && post?.id) {
            dispatch(getLikes(post.id));
        } else if (posts?.length) {
            posts.forEach((p) => dispatch(getLikes(p.id)));
        }
    }, [dispatch, singlepost, post?.id, posts]);

    // ✅ handle like/unlike
    const handleLike = async (postId) => {
        if (!loginUser) {
            const currentPath = location.pathname + location.search;
            navigate(`/login?redirect=${encodeURIComponent(currentPath)}`);
            return;
        }
        try {
            await axios.get("https://api.inspiredformen.com/api/auth/check", {
                withCredentials: true,
            });

            if (liked) {
                await dispatch(deleteLike(postId));
            } else {
                await dispatch(addLike(postId));
            }

            await dispatch(getLikes(postId));  // ✅ Force refresh after action

        } catch (err) {
            console.error("Token expired or invalid:", err.response?.data || err.message);
            dispatch({ type: LOGOUT });
            navigate("/login");
        }
    };

    return (
        <div
            onClick={() => handleLike(post.id)}
            style={{ cursor: "pointer", display: 'flex', alignItems: 'center', gap: '5px' }}
        >
            {liked ? (
                <MdOutlineFavorite style={{ color: "red", fontSize: '20px' }} />
            ) : (
                <MdOutlineFavoriteBorder style={{ fontSize: '20px' }} />
            )}
            <span className="likeCount">
                {postLikes.length === 0 ? "0 like" : postLikes.length === 1 ? "1 like" : `${postLikes.length} likes`}
            </span>
        </div>
    );
}

export default Like;
